import React from 'react';
import { Box, Container, Typography, Link, Stack, useTheme } from '@mui/material';

const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 4, md: 5 },
        backgroundColor: theme.palette.mode === 'light' ? 'grey.100' : 'grey.900',
        borderTop: `1px solid ${theme.palette.divider}`,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 3, sm: 4 }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ 
              textAlign: { xs: 'center', sm: 'left' },
              fontSize: { xs: '0.875rem', sm: '0.9rem' }
            }}
          >
            © {currentYear} CareGuide. All rights reserved.
          </Typography>
          
          <Stack
            direction="row"
            spacing={4}
            sx={{
              '& a': {
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: { xs: '0.875rem', sm: '0.9rem' },
                fontWeight: 500,
                transition: 'color 0.2s ease-in-out',
                '&:hover': {
                  color: 'primary.main',
                  textDecoration: 'none',
                },
              },
            }}
          >
            <Link href="/privacy">Privacy</Link>
            <Link href="/terms">Terms</Link>
            <Link href="/contact">Contact</Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer; 